import React from 'react';

const ChatbotPage = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>chatbot 페이지 예정</h1>
    </div>
  );
};

export default ChatbotPage;
